<template>
  <div id="leader-board" class="d-none d-lg-block pb-2 pt-1 px-3 bg-white">
    <p>
      En Çok Fikir Veren Kişiler
      <MedalSvg />
    </p>

    <div
      class="d-flex my-0 mx-3 py-4 px-1 align-items-center"
      v-for="item in mostSuggestionUsersDataToShow"
      :key="item.UserId"
    >
      <img
        v-if="item.UserPictureId != 0"
        class="flex-shrink-0 fallback-image"
        :src="`data:image/png;base64, ${
          item.UserProfileImage ? item.UserProfileImage : ''
        }`"
        :alt="item.UserName | getInitialsFilter"
      />
      <i
        v-else
        class="flex-shrink-0 fallback-image"
        :alt="item.UserName | getInitialsFilter"
        >{{ item.UserName | getInitialsFilter }}</i
      >
      <div>
        <span class="d-block">{{ item.UserName }}</span>
        <span class="d-block">{{ item.CompanyName }}</span>
        <span class="d-block">Fikir Sayısı: {{ item.SuggestionCount }}</span>
      </div>
    </div>
    <div class="load-more mt-3 mb-0">
      <router-link to="/most-suggestion-all-users">Tümünü Gör</router-link>
    </div>
  </div>
</template>

<script>
import MedalSvg from "./MedalSvg.vue";
import { getInitials } from "../../helpers";
export default {
  name: "PeopleIdea",
  data() {
    return {};
  },
  components: {
    MedalSvg,
  },
  filters: {
    getInitialsFilter(value) {
      return getInitials(value);
    },
  },
  computed: {
    mostSuggestionUsersData() {
      return this.$store.getters["mostSuggestionUsers/mostSuggestionUsersData"];
    },
    mostSuggestionUsersDataToShow() {
      // Show only the first 3 users initially
      return this.mostSuggestionUsersData ? this.mostSuggestionUsersData.slice(0, 3) : [];
    }
  },
  async created() {
    if (!this.mostSuggestionUsersData) {
      await this.$store.dispatch("mostSuggestionUsers/setMostSuggestionUsers");
    }
  },
};
</script>

<style>
.btn-primary {
    background-color: #007bff;
    border-color: #007bff;
}

.load-more {
  text-align: center;
  padding: 10px;
  border-top: 1px solid #eee; /* Optional: adds a separator line */
}

.load-more a {
  color: #666; /* Updated to a grey color similar to "Daha Fazla" */
  text-decoration: none;
  font-weight: normal; /* Adjusted font weight to normal */
  font-size: 0.8em; /* Made the font size a bit smaller */
}

.load-more a:hover {
  text-decoration: none; /* Removed underline on hover */
}
</style>
